import React, { lazy, Suspense } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import MetaData from "../meta-data";
import MainLayout from "../../components/layout/MainLayout";
import SEO from "../../components/seo";
import useConfigData from "../../hooks/useConfigData";

const TrackOrderMain = lazy(() => import("../../components/track-order/TrackOrderMain"));

const Index = () => {
    const { configData, landingPageData, loading } = useConfigData();

    if (loading) {
        return (
            <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '100vh',
                fontSize: '18px'
            }}>
                Loading...
            </div>
        );
    }

  

  
  return (
    <>
      <CssBaseline />
      <SEO
        title={configData ? `Track your order` : "Loading..."}
        image={`${configData?.base_urls?.business_logo_url}/${configData?.fav_icon}`}
        businessName={configData?.business_name}
      />
      <MainLayout configData={configData}>
        <Suspense fallback={<div>Loading...</div>}>
          <TrackOrderMain configData={configData} />
        </Suspense>
      </MainLayout>
    </>
  );
};

export default Index;
